module.exports = __webpack_public_path__ + "img/interest_11.89b1c2e7.png";